import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

type SituacaoCuffa = 'Novo' | 'Em andamento' | 'Finalizado';

type AssinaturaCuffaDraft = {
  signature_uuid?: string;
  latitude?: string;
  longitude?: string;
  coordinate_capture_method?: 'AUTOMATIC' | 'MANUAL';
  __savedAt?: string;
};

type DadosParciais = {
  identificacaoFamiliar?: any;
  visitasInstituicoes?: any;
  producaoAgroecologica?: any;
  producaoConvencional?: any;
  produtosProcessados?: any;
  inspecaoProdutos?: any;
  selosAgregacaoValor?: any;
  canaisComercializacao?: any;
  creditoFinanciamento?: any;
  dificuldadesProducao?: any;
  fontesRendaFamilia?: any;
  participacaoFeminina?: any;
  ultimaRota?: string;
  assinaturaCuffa?: AssinaturaCuffaDraft;
};

interface CuffaStore {
  situacao: SituacaoCuffa;
  collectionUuid: string | null;
  dadosParciais: DadosParciais;
  setSituacao: (situacao: SituacaoCuffa) => void;
  setCollectionUuid: (uuid: string | null) => void;
  salvarDadosParciais: (dados: Partial<DadosParciais>) => void;
  limparDadosParciais: () => void;
  finalizarColeta: (dadosFinais: Partial<DadosParciais>) => void;
  getContinuarPath: (fallbackIncluirPath: string) => string;
}

export const useCuffaStore = create<CuffaStore>()(
  persist(
    (set, get) => ({
      situacao: 'Novo',
      collectionUuid: null,
      dadosParciais: {},


      setSituacao: (situacao: SituacaoCuffa) => set({ situacao }),
      setCollectionUuid: (uuid: string | null) => set({ collectionUuid: uuid }),

      salvarDadosParciais: (dados: Partial<DadosParciais>) =>
        set((state) => ({
          dadosParciais: { ...state.dadosParciais, ...dados },
          situacao: 'Em andamento',
        })),

      setUltimaRota: (path: string) =>
        set((state) => ({
          dadosParciais: { ...state.dadosParciais, ultimaRota: path },
          situacao: state.situacao === 'Novo' ? 'Em andamento' : state.situacao,
        })),

      limparDadosParciais: () =>
        set({
          dadosParciais: {},
          situacao: 'Novo',
          collectionUuid: null,
        }),

      finalizarColeta: (dadosFinais: Partial<DadosParciais>) =>
        set((state) => ({
          dadosParciais: { ...state.dadosParciais, ...dadosFinais },
          situacao: 'Finalizado',
        })),

      getContinuarPath: (fallbackIncluirPath: string): string => {
        const { dadosParciais, collectionUuid } = get();
        let path = dadosParciais?.ultimaRota;

        if (typeof path === 'string' && path.trim()) {
          if (!path.startsWith('/')) path = `/${path}`;
          if (path.includes(':uuid') && collectionUuid) {
            path = path.replace(':uuid', collectionUuid);
          }
          return path;
        }

        if (collectionUuid && fallbackIncluirPath.includes(':uuid')) {
          return fallbackIncluirPath.replace(':uuid', collectionUuid);
        }
        return fallbackIncluirPath;
      },

    }),
    {
      name: 'cuffa-storage',
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        dadosParciais: state.dadosParciais,
        situacao: state.situacao,
        collectionUuid: state.collectionUuid,
      }),
    }
  )
);
